import { getBoxShadow as getInaccessibleBoxShadow } from './boxShadow/themes/InaccessibleLight/alias';
import { getBoxShadow as getLightBoxShadow } from './boxShadow/themes/Light/alias';
export function getBoxShadow(transformer, config) {
    if (config.getTheme() === 'Light') {
        return getLightBoxShadow(transformer);
    }
    if (config.getTheme() === 'Dark' &&
        config.getFeatureFlags().useAccessibleLightTheme.isEnabled()) {
        return getLightBoxShadow(transformer);
    }
    return getInaccessibleBoxShadow(transformer);
}
